import React from 'react';

const CartDetail = (props) => {
    const {name,salary}=props.player
    return (
        <div>
            <li>{name} Salary- {salary}</li>
            
        </div>
    );
};

export default CartDetail;